import { currentDevice } from '../../utils/currentDevice'

if (IB === undefined) IB = {};
IB.currentDevice = currentDevice.type;
